module.exports = __webpack_public_path__ + "media/images/story/top/step1-ebb2f796a481fb6c220ce86bb99b217c.svg";